import * as Sentry from '@sentry/angular';

import { environment } from '../../environments/environment';

export const sentryConfig = () => {
  if (environment.production || environment.qa) {
    Sentry.init({
      dsn: environment.sentry.dsn,
      allowUrls: environment.sentry.allowUrls,
      environment: environment.production ? 'production' : environment.name,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: environment.sentry.tracesSampleRate,
      tracePropagationTargets: environment.sentry.tracePropagationTargets,
      replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
      replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate
    });
  }
};
